import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 24px;
  height: 24px;
  color: var(--wg-grey);
`

// TODO Remove plain option and create a new icon
function Check({ title = 'Check', plain, ...rest }: IconProps & { plain?: boolean }) {
  return (
    <StyledIcon viewBox="0 0 24 24" title={title} {...rest}>
      <g className="prefix__nc-icon-wrapper">
        <path
          d="M4.549 19.107L.171 14 2 12l3.834 3.006L17 3l2 1L7.664 19.011a2 2 0 01-3.115.096z"
          fill="currentColor"
        />
        {!plain && <path fill="currentColor" d="M19 7h5v2h-5zM15 12h9v2h-9zM12 17h12v2H12z" />}
      </g>
    </StyledIcon>
  )
}

Check.needsWork = true
export default Check
